import React, { useState, useEffect, useCallback } from "react";
import { X, Trash, ChatCircle, Plus } from "@phosphor-icons/react";
import { http } from "../lib/api";

export default function HistorySheet({ open, onClose, deviceId, currentSessionId, onSelect, onNewChat }) {
  const [sessions, setSessions] = useState([]);

  const load = useCallback(() => {
    http.get(`/sessions?device_id=${deviceId}`)
      .then((r) => setSessions(r.data.filter((session) => session.message_count > 0)))
      .catch((e) => console.warn("Chat-Verlauf laden fehlgeschlagen:", e));
  }, [deviceId]);

  useEffect(() => {
    if (open) load();
  }, [open, load]);

  if (!open) return null;

  const remove = async (id) => {
    await http.delete(`/sessions/${id}?device_id=${deviceId}`).catch((e) => console.warn("Chat löschen fehlgeschlagen:", e));
    if (id === currentSessionId) onNewChat();
    load();
  };

  const fmtDate = (iso) => new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "2-digit" });

  return (
    <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-xl flex items-end sm:items-center justify-center" onClick={onClose}>
      <div
        data-testid="history-sheet"
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-lg bg-bg border border-white/10 rounded-t-2xl sm:rounded-2xl max-h-[85dvh] flex flex-col"
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <h2 className="font-heading text-xl font-bold tracking-tight">CHAT-VERLAUF</h2>
          <button data-testid="history-close-btn" onClick={onClose} className="p-2 rounded-full bg-elevated border border-white/10">
            <X size={16} weight="bold" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-2">
          {sessions.length === 0 && <p className="text-muted text-sm text-center py-8">Noch keine Chats vorhanden.</p>}
          {sessions.map((s) => (
            <div
              key={s.id}
              data-testid="history-item"
              className={`flex items-center gap-3 rounded-xl border p-3.5 transition-colors ${
                s.id === currentSessionId ? "border-volt bg-volt/10" : "border-white/10 bg-surface hover:border-white/25"
              }`}
            >
              <button
                className="flex-1 min-w-0 text-left flex items-start gap-2.5"
                onClick={() => {
                  onSelect(s.id);
                  onClose();
                }}
              >
                <ChatCircle size={19} weight="duotone" className="text-volt mt-0.5 shrink-0" />
                <span className="min-w-0">
                  <span className="block text-sm font-medium truncate">{s.title || "Chat"}</span>
                  <span className="block text-xs text-muted">
                    {fmtDate(s.created_at)} · {s.message_count} Nachricht{s.message_count !== 1 ? "en" : ""}
                  </span>
                </span>
              </button>
              <button
                data-testid="history-delete-btn"
                onClick={() => remove(s.id)}
                className="p-2 text-muted hover:text-red-400 transition-colors"
              >
                <Trash size={16} />
              </button>
            </div>
          ))}
        </div>
        <div className="p-4 border-t border-white/10">
          <button
            data-testid="history-new-chat-btn"
            onClick={() => {
              onNewChat();
              onClose();
            }}
            className="w-full flex items-center justify-center gap-2 bg-volt hover:bg-volthover active:scale-[0.98] transition-all rounded-xl py-3.5 font-bold text-sm"
          >
            <Plus size={16} weight="bold" /> Neuer Chat
          </button>
        </div>
      </div>
    </div>
  );
}
